import React from "react";

function AmlBadge({ status }) {
  function formatString(input) {
    if (!input) return "---";
    return input
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  }
  const getBadgeColor = (status) => {
    switch (status) {
      case "low_risk":
        return "bg-[#218838]";
      case "medium_risk":
        return "bg-[#d4af37]";
      case "blocked":
        return "bg-[#c82333]";
      case "high_risk":
        return "bg-[#e65100]";
      default:
        return "bg-[#f8e9e8]";
    }
  };
  return (
    <p
      className={`text-white  w-[90px] h-[20px] rounded flex justify-center items-center text-[11px] font-medium  ${getBadgeColor(
        status
      )} `}
    >
      {formatString(status) || "---"}
    </p>
  );
}

export default AmlBadge;
